module.exports = __webpack_public_path__ + "img/8-1-283x400.67395b27.jpg";